import * as React from 'react';

export const Video = (props: {
  className: string;
  media: MediaStream;
  muted: boolean;
}) => {
  const ref = React.useRef(null as HTMLVideoElement | null);

  React.useEffect(() => {
    if (!ref.current) {
      return;
    }
    const video = ref.current;
    if ('srcObject' in video) {
      video.srcObject = props.media;
    } else {
      // For older browsers
      (video as any).src = window.URL.createObjectURL(props.media as any);
    }
  }, [ref, props.media]);
  return (
    <video
      autoPlay
      playsInline
      muted={props.muted}
      controls={false}
      ref={ref}
      className={props.className}
    ></video>
  );
};
